<nav
  id="main-header"
  class="main-header navbar navbar-expand"
  :class="navbarVariant"
>
  <ul class="navbar-nav">
    <h4><b>HIAE</b> TRAUMA</h4>
  </ul>

  <ul class="navbar-nav ml-auto">
    <menu-header v-if="isMasterUser"></menu-header>
    <user-logout></user-logout>
  </ul>
</nav>
